import React, { useEffect, useMemo, useRef } from "react";
import { Bold, Italic, List, ListOrdered, Quote, Redo2, Underline, Undo2 } from "lucide-react";

const TOOLBAR_ACTIONS = [
    { command: "bold", icon: Bold, label: "Gras" },
    { command: "italic", icon: Italic, label: "Italique" },
    { command: "underline", icon: Underline, label: "Souligné" },
    { command: "insertUnorderedList", icon: List, label: "Liste à puces" },
    { command: "insertOrderedList", icon: ListOrdered, label: "Liste numérotée" },
    { command: "formatBlock", value: "blockquote", icon: Quote, label: "Citation" },
    { command: "undo", icon: Undo2, label: "Annuler" },
    { command: "redo", icon: Redo2, label: "Rétablir" },
];

export default function HtmlRichEditor({
    value = "",
    onChange,
    placeholder = "Rédigez votre contenu ici...",
    hint = "",
}) {
    const editorRef = useRef(null);
    const lastValueRef = useRef(value || "");

    useEffect(() => {
        if (!editorRef.current) return;
        if ((value || "") !== lastValueRef.current) {
            editorRef.current.innerHTML = value || "";
            lastValueRef.current = value || "";
        }
    }, [value]);

    const handleInput = () => {
        const html = editorRef.current?.innerHTML || "";
        lastValueRef.current = html;
        onChange?.(html);
    };

    const exec = (command, commandValue = null) => {
        editorRef.current?.focus();
        try {
            document.execCommand(command, false, commandValue);
        } catch (error) {}
        handleInput();
    };

    const toolbar = useMemo(
        () =>
            TOOLBAR_ACTIONS.map((action) => {
                const Icon = action.icon;
                return (
                    <button
                        key={`${action.command}-${action.value || ""}`}
                        type="button"
                        className="mcp-editor__tool"
                        title={action.label}
                        onClick={() => exec(action.command, action.value)}
                    >
                        <Icon size={15} />
                    </button>
                );
            }),
        []
    );

    return (
        <div className="mcp-editor">
            <div className="mcp-editor__toolbar">{toolbar}</div>
            <div
                ref={editorRef}
                className="mcp-editor__surface"
                contentEditable
                suppressContentEditableWarning
                data-placeholder={placeholder}
                onInput={handleInput}
            />
            {hint ? <div className="mcp-editor__hint">{hint}</div> : null}
        </div>
    );
}
